import type { SxProps } from '@mui/material';
import type React from 'react';
import { HeroImageBackgroundComponent } from '@/admins/SmartReports/components/Components/Images';
import type { ComponentEditProps } from '@/admins/SmartReports/components/Components/types';
import { LogoBox } from '@/admins/SmartReports/components/Layouts/components';
import { TitleBoxTypography } from '@/admins/SmartReports/components/Layouts/components/TitleBoxTypography';
import { SlotView } from '@/admins/SmartReports/components/Slots/SlotView';
import { WelligenceLogo } from '@/components/WelligenceLogo';
import type { Portfolio, SmartReportPage } from '@/types/GraphqlSchema';
import { styles } from './styles';
import { SlotsEnum } from './types';

type TitlePageLiveThumbnailProps = {
  pageData: SmartReportPage;
  portfolio: Portfolio;
  sx: SxProps;
  onClick?: () => void;
};

export const TitlePageThumbnail = ({
  portfolio,
  pageData,
  sx,
  onClick,
}: TitlePageLiveThumbnailProps) => {
  const pageElement = pageData?.pageElements?.find(el => el.slotId === SlotsEnum.BackgroundImage);
  const countryIsoCode = pageElement?.data;

  const BackgroundComponent = HeroImageBackgroundComponent.Thumbnail as React.ComponentType<
    ComponentEditProps<string>
  >;

  return (
    <div onClick={onClick} style={{ display: 'contents' }}>
      <BackgroundComponent
        sx={{ ...styles.titlePageRootThumbnail, ...sx }}
        persistedData={countryIsoCode}
        portfolio={portfolio}
        onComponentLoad={() => {}}
      >
        <LogoBox sx={styles.logoBoxThumbnail}>
          <WelligenceLogo />
        </LogoBox>

        <TitleBoxTypography sx={{ ...styles.typography1, ...styles.typographyThumbnail }}>
          <SlotView pageData={pageData} slotId={SlotsEnum.Title} />
        </TitleBoxTypography>
        <TitleBoxTypography sx={{ ...styles.typography2, ...styles.typographyThumbnail }}>
          <SlotView pageData={pageData} slotId={SlotsEnum.Subtitle} />
        </TitleBoxTypography>
        <TitleBoxTypography sx={{ ...styles.typography3, ...styles.typographyThumbnail }}>
          <SlotView pageData={pageData} slotId={SlotsEnum.Subtitle2} />
        </TitleBoxTypography>
      </BackgroundComponent>
    </div>
  );
};
